



<div class="search">
    <button *ngIf="hasSiteManagement" class="btn btn-success btn-purchasenewpack" (click)="exportUserData()">Export User Data</button>
    <button class="btn btn-info btn-purchasenewpack" (click)="addUser()">Add New User </button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]="'Search Users'" (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>

<div *ngIf="hasSiteManagement" style="white-space: nowrap;">
	<span style="margin-left: 15px; vertical-align: middle; text-align: center;">Show Inactive Users</span>
	<label class="switch" style="margin-left: 5px; margin-top: 5px; vertical-align: middle; text-align: center;">	
	<input		
		id="shouldNotifyUserCreated" 
        type="checkbox" class="form-control"
        [(ngModel)]="displayInactive" 
		(change)="filterUsers();">
	<span class="slider round"></span>
    </label>
    
    <span style="padding-left: 15px; vertical-align: middle; text-align: center;">Filter by Organization</span>
    <select
            style="width: 200px; color: black; height: 37px; margin-left: 5px; display: inline;"
            id="organization"
            class="form-control m-input"
            (change)="filterUsers();" 
            [(ngModel)]="selectedOrganization"
            name="organization">
        <option 												      
            [ngValue]="org">
            -- Reset Selection --
        </option>
        <option *ngFor="let org of organizations" 													      
            [ngValue]="org">
            {{org.name}}
        </option>
        
    </select>

    <span style="padding-left: 10px; vertical-align: middle; text-align: center;">Filter by Application</span>
    <select
            style="width: 200px; margin-left: 5px; color: black; height: 37px; display: inline;"
            id="application"
            class="form-control m-input"
            (change)="filterUsers();" 
            [(ngModel)]="selectedEngine"
            name="application">
        <option 												      
            [ngValue]="app">
            -- Reset Selection --
        </option>
        <option *ngFor="let app of engines" 													      
            [ngValue]="app">
            {{app.applicationName}}
        </option>
        
    </select>
</div>
</div>



<br>

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>


<ngx-datatable #userTable
               class='material striped datatable'
               [rows]='displayUsers'
               [columnMode]='"force"'
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [reorderable]="reorderable"
               [messages]="{emptyMessage:'No users available or you do not have permission to view users'}">

        <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="160" [maxWidth]="160" >
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span>
                
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            <button *ngIf="!reportActivity && row.active" (click)="deleteUser(row.userId)">Delete</button>
            <button *ngIf="!reportActivity && !row.active" (click)="enableUser(row.userId)">Enable</button>
            <button *ngIf="!reportActivity" (click)="editUser(row.userId)">Edit</button>
            <button *ngIf="!reportActivity" (click)="openMoreActions(row)">More</button>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="email" [sortable]="true" [width]="250">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Email
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.email}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="phoneNumber" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Phone Number
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.phoneNumber}}
        </ng-template>
    </ngx-datatable-column>  

    <ngx-datatable-column prop="organization.name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Organization
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.organization.name}}
        </ng-template>
    </ngx-datatable-column>   

    <ngx-datatable-column prop="clientType.name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Client Type / Code
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.clientType.name}} / {{row.clientType.code}}
        </ng-template>
    </ngx-datatable-column>  

    <ngx-datatable-column prop="role.name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Role
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.role.name}}
        </ng-template>
    </ngx-datatable-column>  

    <ngx-datatable-column prop="userApplication.name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                User Application
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.engine.applicationName}}
        </ng-template>
    </ngx-datatable-column>  

    <ngx-datatable-column prop="lastActive" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Last Active (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.lastActive | date:'MM-dd-yyyy hh:mm a z'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="created" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Date Created (UTC)
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.created | date:'MM-dd-yyyy hh:mm a z'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="createdBy" [sortable]="true" [width]="250">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Created By
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.createdBy}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="active" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Active
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.active}}
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>






